export const POST_POI_PACKAGE_DATA_TYPE = {
    POST_POI_PACKAGE: 'POST_POI_PACKAGE',
    POST_POI_PACKAGE_STARTED: 'POST_POI_PACKAGE_STARTED',
    POST_POI_PACKAGE_SUCCESS: 'POST_POI_PACKAGE_SUCCESS',
    POST_POI_PACKAGE_FAILED: 'POST_POI_PACKAGE_FAILED',
    POST_POI_PACKAGE_RESET: 'POST_POI_PACKAGE_RESET',
    GET_POI_PACKAGE_BY_ID: 'GET_POI_PACKAGE_BY_ID',
    GET_POI_PACKAGE_BY_ID_STARTED: 'GET_POI_PACKAGE_BY_ID_STARTED',
    GET_POI_PACKAGE_BY_ID_SUCCESS: 'GET_POI_PACKAGE_BY_ID_SUCCESS',
    GET_POI_PACKAGE_BY_ID_FAILED: 'GET_POI_PACKAGE_BY_ID_FAILED',
    GET_POI_PACKAGE_BY_ID_RESET: 'GET_POI_PACKAGE_BY_ID_RESET',
    PUT_POI_PACKAGE_REMOVE_POI: 'PUT_POI_PACKAGE_REMOVE_POI',
    PUT_POI_PACKAGE_REMOVE_POI_STARTED: 'PUT_POI_PACKAGE_REMOVE_POI_STARTED',
    PUT_POI_PACKAGE_REMOVE_POI_SUCCESS: 'PUT_POI_PACKAGE_REMOVE_POI_SUCCESS',
    PUT_POI_PACKAGE_REMOVE_POI_FAILED: 'PUT_POI_PACKAGE_REMOVE_POI_FAILED',
    PUT_POI_PACKAGE_REMOVE_POI_RESET: 'PUT_POI_PACKAGE_REMOVE_POI_RESET',
  };

  export const API_URL = {
    POST_POI_PACKAGE: 'screeniq/v2/package/poi',
    GET_POI_PACKAGE_BY_ID: 'screeniq/pois/:id',
    PUT_POI_PACKAGE_REMOVE_POI: 'screeniq/v2/poi-package/update',
  };

  export const API_METHOD = {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    DELETE: 'DELETE',
  };